export const RESET_ERROR = 'carmen/RESET_ERROR';

export const GET_CARMEN_VEHICLE_SUCCESS = 'carmen/GET_CARMEN_VEHICLE_SUCCESS';
export const GET_CARMEN_VEHICLE_FAIL = 'carmen/GET_CARMEN_VEHICLE_FAIL';
export const UPDATE_CARMEN_VEHICLE_SUCCESS = 'carmen/UPDATE_CARMEN_VEHICLE_SUCCESS';
export const UPDATE_CARMEN_VEHICLE_FAIL = 'carmen/UPDATE_CARMEN_VEHICLE_FAIL';

export const GET_CARMEN_USERS_SUCCESS = 'carmen/GET_CARMEN_USERS_SUCCESS';
export const GET_CARMEN_USERS_FAIL = 'carmen/GET_CARMEN_USERS_FAIL';
export const UPDATE_CARMEN_USER_SUCCESS = 'carmen/UPDATE_CARMEN_USER_SUCCESS';
export const UPDATE_CARMEN_USER_FAIL = 'carmen/UPDATE_CARMEN_USER_FAIL';
